import { NavigationSubItem } from "../navigation-item"

export class CreateManualClLiquiditySubItem extends NavigationSubItem {
  readonly id = "create-manual-cl"
  readonly label = "Create"
  readonly href = "/liquidity/cl/v1/create"
  readonly iconName = "manual-icon"
  readonly isExternal = false
  readonly tabs = []
}
